import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { cacheKeys } from '../../cacheKeys';
import { QueryConfig } from '@/react-query';
import { GetInstitutionsPublicRequest, GetInstitutionsPublicResponse } from './getInstitutionsPublic.types';
import { getInstitutionsPublic } from './getInstitutionsPublic.api';

type GetInstitutionsPublicOptions = QueryConfig<typeof getInstitutionsPublic>;

const EMPTY_INSTITUTIONS: GetInstitutionsPublicResponse = [];

export function useInstitutionsPublic(
  request: GetInstitutionsPublicRequest = {},
  options: GetInstitutionsPublicOptions = {}
) {
  const { data, ...rest } = useQuery<GetInstitutionsPublicResponse, AxiosError<unknown>>({
    queryKey: cacheKeys.getInstitutionsPublic(request),
    queryFn: async () => await getInstitutionsPublic(request),
    staleTime: 5000,
    ...options
  });

  return { institutions: data || EMPTY_INSTITUTIONS, ...rest };
}
